import * as immutable from 'immutable';
import { Bank as BankPresenter } from './presenter';
import { connect } from '../../../common/react-redux';
import BankRecord from '../../../common/records/Bank';
import { getActiveQuiz } from '../../../common/selectors/quizzes';
import { getBank, getSharedBank, shareBank, updateSharedBankPermission } from '../../../banks/api/banks';
import { getBankEntries } from '../../../banks/api/bankEntries';
import { createQuizEntry } from '../../../building/api/quizEntries';
import { openModal, withConfirm } from '../../../common/actions/modal';
import { BUILD_TRAY_POSITION, BUILD_TRAY_STIMULUS_ID } from '@instructure/quiz-common';
import { screenreaderNotification } from '../../../common/actions/alerts';
import { reset as resetSearch } from '../../../common/actions/bankSearch';
import { removeSharedBank } from '../../../common/actions/sharedBanks';
import { featureOn } from '../../../common/util/featureCheck';
export function mapStateToProps(state, props) {
  var bank = new BankRecord(state.getIn(['banks', props.bankId]));
  var search = state.get('bankSearch', immutable.Map());
  var courseSharedBank = state.get('sharedBanks', immutable.Map()).find(function (sharedBank) {
    return sharedBank.get('bankId') === props.bankId && sharedBank.get('entityType') === props.scope.type && sharedBank.get('entityId') === props.scope.uuid;
  });
  var activeQuiz = getActiveQuiz(state);
  var lockBlueprintContentEnabled = featureOn('lock_blueprint_content');
  var isQuizContentLocked = activeQuiz && activeQuiz.originalQuizLockedByBlueprint && lockBlueprintContentEnabled;
  return {
    bank: bank,
    isQuizContentLocked: isQuizContentLocked,
    search: search,
    courseSharedBank: courseSharedBank,
    useBankSearch: featureOn('item_bank_search'),
    position: state.getIn(['ui', BUILD_TRAY_POSITION]),
    stimulusId: state.getIn(['ui', BUILD_TRAY_STIMULUS_ID]),
    activeQuizId: state.getIn(['quizzes', 'activeQuizId']),
    showShareBankFromTray: featureOn('share_bank_from_tray')
  };
}
var mapDispatchToProps = {
  addEntryToQuiz: createQuizEntry,
  getBank: getBank,
  getBankEntries: getBankEntries,
  getSharedBank: getSharedBank,
  openModal: openModal,
  removeSharedBank: removeSharedBank,
  resetSearch: resetSearch,
  screenreaderNotification: screenreaderNotification,
  shareBank: shareBank,
  updateSharedBankPermission: updateSharedBankPermission,
  withConfirm: withConfirm
};
export var Bank = connect(mapStateToProps, mapDispatchToProps)(BankPresenter);
export default Bank;